module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-797e56ff130658144e4e490d624a90ef.svg";